module.exports = __webpack_public_path__ + "img/user_hl_lx.6b3ca9c8.png";